export default __webpack_public_path__ + "static/media/PncBank.f81977dd.svg";